export const validPhoneRegex = /^(\+7([0-9]{10}))|(\+375([0-9]{9,10}))|(\+374([0-9]{8}))$/;
